import { tap } from 'lodash/fp';
import AnalyticsConstants from '../analytics/constants';
import {
  createAndSendButtonSubmissionAnalyticsEventForMultipleSkus,
} from '../analytics/commonAnalytics';
import * as types from './actionTypes';
import estimateLoaded from './estimateLoaded';
import loading from './loading';
import loaded from './loaded';
import addContainer from './addContainer';
import resetContainerCount from './resetContainerCount';
import { deleteContainer } from '../api/designBuilder';
import globalError from './globalError';

const containerDeleted = (designId, containerId, itemIds) => ({
  type: types.CONTAINER_DELETED,
  payload: { designId, containerId, itemIds },
});

export default (designId, containerId) => (dispatch, getState) => {
  dispatch(loading());

  const { estimates, containers, items } = getState().estimateBuilder.entities;
  const theEstimatesContainerCountBeforeDeletion = estimates.byId[designId].containers.length;
  const affectedItems = containers.byId[containerId].items;

  return deleteContainer(designId, containerId)
    .then((response) => {
      createAndSendButtonSubmissionAnalyticsEventForMultipleSkus(
        items,
        containerId,
        window.globalConfig.siteId,
        AnalyticsConstants.EventNames.DesignRemoveProduct,
      );

      dispatch(containerDeleted(designId, containerId, affectedItems));
      dispatch(estimateLoaded(response.data));

      if (theEstimatesContainerCountBeforeDeletion === 1) {
        dispatch(resetContainerCount(designId));
        addContainer(designId)(dispatch, getState);
      }
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
